<template>
    <div class="yh-page">
      <el-card>
        <el-row slot="header" type="flex" justify="space-between" align="middle" class="p-3" :gutter="10">
          <el-col :span="20">
            <el-input placeholder="输入船东信息进行搜索..." v-model.trim="query.search"
                      @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" v-loading="searching" @click="handleSearch">搜索</el-button>
            </el-input>

          </el-col>
          <el-col :span="4">
          <el-select placeholder="请选择状态" v-model="query.status" filterable clearable @change="handleSearch">
              <el-option v-for="g in statusList" :key="g.id" :value="g.value" :label="g.name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button type="primary" size="small"  @click="deductionExport">导出抵扣申请书</el-button>
            <el-button type="primary" size="small"  @click="handldBatchSuccess" v-if=" $perm(['group_insurance.auditing_deduction_apply'])">审核通过(业管)</el-button>
            <el-button type="primary" size="small"  @click="handldBatchSuccessFinance" v-if="$perm(['group_insurance.update_deduction_apply'])">审核通过(财务)</el-button>
            <el-button type="primary" size="small"  @click="handldBatchSuccessFinanceLead" v-if="$perm(['group_insurance.update_deduction_apply'])">审核通过(财务主管)</el-button>
          </el-col>
        </el-row>
        <div>
          <el-table :key="0" :data="list" stripe v-loading="listLoading" :element-loading-text="loadingText" fit
                    highlight-current-row class="w-100" @selection-change="handleSelectionChange">
            <!-- 客户名称 -->
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column align="left" label="会员名称">
              <template slot-scope="scope">
                <span>{{scope.row.member_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="活动">
              <template slot-scope="scope">
                <span>{{scope.row.activity_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="抵扣类型">
              <template slot-scope="scope">
                <span>{{scope.row.type_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="抵扣船名">
              <template slot-scope="scope">
                <span>{{scope.row.deduction_ship_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="被抵扣账户船名">
              <template slot-scope="scope">
                <span>{{scope.row.ship_name}}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="状态">
              <template slot-scope="scope">
                <span>{{ statusList.find(o => o.value==scope.row.status) ? statusList.find(o => o.value==scope.row.status).name : '' }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="抵扣金额">
              <template slot-scope="scope">
                <span>{{scope.row.sum_account }}</span>
              </template>
            </el-table-column>

            <el-table-column align="left" label="调差金额">
              <template slot-scope="scope">
                <span>{{scope.row.adjustment_amount}}</span>
              </template>
            </el-table-column>

       
            <!-- 更新人 -->
            <el-table-column align="left" label="创建人">
              <template slot-scope="scope">
                <span>{{scope.row.updater_name ? scope.row.updater_name :scope.row.creator_name}}</span>
              </template>
            </el-table-column>
            <!-- 创建时间 -->
            <el-table-column align="left" label="创建时间">
              <template slot-scope="scope">
                <span>{{ scope.row.create_time | parseTime }}</span>
              </template>
            </el-table-column>


    
            <el-table-column align="left" label="操作">
              <template slot-scope="scope">
                <el-tooltip effect="light" content="提交审核" placement="top-start" v-show="[0,3].indexOf(scope.row.status) !== -1">
                  <el-button type="text" class="pr-1" @click="handleSubmit(scope.row)">
                    <i class="el-icon-s-promotion"></i>
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="light" content="业管审核" placement="top-start" v-if="scope.row.status == 1 && $perm(['group_insurance.auditing_deduction_apply'])">
                    <el-button type="text" class="pr-1" @click="handleSuccess(scope.row)">
                        <i class="el-icon-document-checked"></i>
                    </el-button>
                </el-tooltip>
                <!-- <el-tooltip effect="light" placement="top-start" content="编辑" v-show="[0,3].indexOf(scope.row.status) !== -1">
                  <el-button type="text" @click="handleEdit(scope.row)">
                    <i class="el-icon-edit"></i>
                  </el-button>
                </el-tooltip> -->
                <!-- <el-tooltip effect="light" placement="top-start" content="业务主管审核" >
                  <el-button type="text" @click="handleBusinessAuditing(scope.row)" v-show="[6].indexOf(scope.row.status) !== -1">
                    <i class="el-icon-s-check"></i>
                  </el-button>
                </el-tooltip> -->

                <el-tooltip effect="light" placement="top-start" content="审核或调整差额" v-if="[2,7].indexOf(scope.row.status) !== -1 && $perm(['group_insurance.update_deduction_apply'])">
                  <el-button type="text" @click="handleAdjust(scope.row)">
                    <i class="el-icon-sort"></i>
                  </el-button>
                </el-tooltip>
                
                <el-tooltip effect="light" placement="top-start" content="查看">
                    <el-button type="text" @click="handleUpdate(scope.row)" ><i class="el-icon-view"></i></el-button>
                </el-tooltip>

                
                <el-tooltip effect="light" placement="top-start" content="撤销申请">
                  <el-button type="text" @click="handleDelete(scope.row)" v-show="[0,1,3].indexOf(scope.row.status) !== -1">
                    <i class="el-icon-refresh-right"></i>
                  </el-button>
                </el-tooltip>

                
                <el-tooltip effect="light" placement="top-start" content="确认通过" >
                  <el-button type="text" @click="handleAuditing(scope.row)" v-show="[2,7].indexOf(scope.row.status) !== -1 && $perm(['group_insurance.update_deduction_apply'])">
                    <i class="el-icon-success"></i>
                  </el-button>
                </el-tooltip>


                <el-tooltip effect="light" content="上传" placement="top-start">
                  <el-button type="text" class="pr-1" @click="handleUpload(scope.row)">
                    <i class="el-icon-upload"></i>
                  </el-button>
                </el-tooltip>

                
                <el-tooltip effect="light" placement="top-start" content="导出记录" >
                  <el-button type="text" @click="handleDownload(scope.row)" v-show="[5].indexOf(scope.row.status) !== -1">
                    <i class="el-icon-download"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <pagination-new :size.sync="query.limit" :offset.sync="query.offset" :total="total"
                      @updateList="getList"></pagination-new>
          <upload-dialog ref="upload"
                  :object-name="object_name"
                  :file-type-list="file_type_list"
                  object-type="group_insurance.insurancedeductionapply"
                  :object-id="apply_id"
                  :is-upload="true"
                  @uploaded="handleAppended">
              </upload-dialog>
              </div>
            </el-card>
            <el-dialog title="填写签署日期" :visible.sync="dialogVisible">
            <el-form label-position="right" label-width="150px" v-loading="downloading" >
              <el-row>
                <el-col>
                  <el-form-item label="签署日期">
                    <el-date-picker
                      v-model="write_date"
                      type="date"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="border-top mt-2 pt-3">
                  <el-form-item>
                    <el-button size="small" type="primary" style="float: right" @click="handlePrint">导出</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-dialog>
          <el-dialog :visible.sync="SuggestionVisible" width="50%">
                <el-form ref="refuse_reason"  label-width="120px">
                <el-form-item label="备注" width="50%">
                    <el-input type="textarea"  :rows="10" v-model="refuse_reason"></el-input>
                </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handldBatchSuccessBusiness" v-show="result === 1">确认通过</el-button>
                <el-button type="primary" @click="handldBatchSuccessByFinance" v-show="result === 2">确认通过</el-button>
                </span>
            </el-dialog>
      <make-document-dialog ref="makeDocument"
                            :command_list="command_list"
                            :data="multipleSelection">
      </make-document-dialog>
       
 
    </div>
  </template>
  
  <script>
    import {parseTime} from '@/utils'
    import PaginationNew from '@/components/PaginationNew'
    import {rejectShipApply,successShipQuit} from '@/api/member'
    import UploadDialog from "@/components/UploadDialog"
    import { getDeductionList,submitDeductionApply,DeleteDeductionApply,financeSuccessDeductionApply,exportDeductionApply,batchDeductionSuccessApply,batchUpdateDeductionApply,batchFinanceDeductionSuccessApply,exportDeductionDeatil} from '@/api/group-insurance'
    import MakeDocumentDialog from '@/views/ib/group-insurance/make-document-dialog'
    import { fetchFileTypeList } from "@/api/common"
  
    export default {
      name: "DeductionApplyList",
      components: {
        PaginationNew,
        UploadDialog,
        MakeDocumentDialog
      },
      filters: {
        parseTime
      },
      data() {
        return {
          list:[],
          query: {
            search: '',
            offset: 0,
            limit: 20,
          },
          searching: false,
          downloading:false,
          refuse_reason:null,
          dialogVisible:false,
          SuggestionVisible:false,
          multipleSelection:[],
          write_date:null,
          result:null,
          listLoading: false,
          loadingText: '正在加载船东数据，请稍等...',
          list: [],
          command_list:[],
          file_type_list:[],
          statusList:[
              {id: 0, name: '已创建','value':0},
              {id: 1, name: '已提交审核','value':1},
              {id: 2, name: '业管已通过','value':2},
              {id: 7, name: '财务已调整','value':7},
              {id: 3, name: '已拒绝','value':3},
              {id: 4, name: '已撤销','value':4},
              {id: 5, name: '申请成功','value':5},

            ],
          total: 0,
          object_name:'',
          apply_id:'',
        }
      },
      methods: {
        handleDownload(row){
          this.downloading = true
            exportDeductionDeatil(row.id).then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'
                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)
                
                link.download = '抵扣申请记录.pdf'
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.downloading = false
            }).catch(error => {
                this.downloading = false
                this.$error_message(error)
            })
        },
        handldBatchSuccessFinanceLead(){
            if (this.multipleSelection.length === 0) {
                  this.$error_message("请选择抵扣申请！")
                  return
                }
            let is_exist = 0
            this.multipleSelection.forEach((item, index) => {
            if([2,7].indexOf(item.status) === -1){
                  is_exist = 1
                }
              })
            if (is_exist === 1){
              this.$error_message("选择的申请中有不符合审核状态的数据，请检查！")
                return
            }
          var msg = '是否批量通过申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            batchFinanceDeductionSuccessApply({"data":this.multipleSelection,"remark":this.refuse_reason})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '通过成功!'
                })
                this.getList()
                this.SuggestionVisible = false
              })
              .catch(error => {
                this.$message.error(error)
              })
          })

        },
        handldBatchSuccessFinance(){
            if (this.multipleSelection.length === 0) {
                  this.$error_message("请选择抵扣申请！")
                  return
                }
            let is_exist = 0
            this.multipleSelection.forEach((item, index) => {
            if([2,7].indexOf(item.status) === -1){
                  is_exist = 1
                }
              })
            if (is_exist === 1){
              this.$error_message("选择的申请中有不符合审核状态的数据，请检查！")
                return
            }
            this.SuggestionVisible = true
            this.result = 2
        },
        handldBatchSuccessByFinance(){        
          var msg = '是否批量通过申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            batchUpdateDeductionApply({"data":this.multipleSelection,"remark":this.refuse_reason})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '通过成功!'
                })
                this.getList()
                this.SuggestionVisible = false
              })
              .catch(error => {
                this.$message.error(error)
              })
          })

        },

        handldBatchSuccess() {
            if (this.multipleSelection.length === 0) {
                  this.$error_message("请选择抵扣申请！")
                  return
                }
            let is_exist = 0
            this.multipleSelection.forEach((item, index) => {
            if(item.status !== 1){
                  is_exist = 1
                }
              })
            if (is_exist === 1){
              this.$error_message("选择的申请中有不符合审核状态的数据，请检查！")
                return
            }
            this.SuggestionVisible = true
            this.result = 1
        },
        handldBatchSuccessBusiness(){        
          var msg = '是否批量通过申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            batchDeductionSuccessApply({"data":this.multipleSelection,"refuse_reason":this.refuse_reason})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '通过成功!'
                })
                this.getList()
                this.SuggestionVisible = false
              })
              .catch(error => {
                this.$message.error(error)
              })
          })

        },
        deductionExport(){
          if (this.multipleSelection.length === 0) {
                this.$error_message("请选择抵扣申请！")
                return
              }
          this.dialogVisible = true
        },
        handlePrint(){
          exportDeductionApply({data:this.multipleSelection,write_date:this.write_date})
            .then(res => {
                let link = document.createElement('a')
                link.style.display = 'none'

                let blob = new Blob([res])
                link.href = URL.createObjectURL(blob)

                let ext_name = '.pdf'
                link.download = "风险准备金抵扣申请书" + ext_name
                document.body.appendChild(link)

                link.click()
                URL.revokeObjectURL(blob)
                document.body.removeChild(link)
                this.assignVisible = false
                this.downloading = false
            })
            .catch(error => {
                this.downloading = false
                let reader = new FileReader()
                reader.onload = e => {
                  if (e.target.readyState === 2) {
                    let res = {}
                    res = JSON.parse(e.target.result)
                    this.$error_message(res)
                  }
                }
                reader.readAsText(error)
            })
        },
        handleSelectionChange(val) {
          this.multipleSelection = val;
        },
        setQueryStorage() {
          window.localStorage.setItem('query', JSON.stringify(this.query))
        },
        handleAuditing(row){
          this.$confirm('是否确认通过该抵扣申请？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                financeSuccessDeductionApply({id: row.id})
                  .then(res => {
                    if (res.code === 1) {
                      this.$message.success(res.message)
                    }
                    else {
                      this.$error_message(res.message)
                    }
                    this.getList()
                  })
                  .catch(err => {
                    this.$error_message(err)
                  })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
        },
        handleDelete(row){
          this.$confirm('是否撤销该抵扣申请？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                DeleteDeductionApply({id: row.id})
                  .then(res => {
                    this.$message.success("撤销成功！")
                    this.getList()
                  })
                  .catch(err => {
                    this.$error_message(err)
                  })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
        },
        handleAdjust(row){
          this.setQueryStorage()
          this.$router.push({ name: 'deductionApplyDetail', query: {'type': 'ApplyAdjust', 'id': row.id}})
        },
        handleEdit(row){
          this.setQueryStorage()
          this.$router.push({ name: 'deductionApplyDetail', query: {'type': 'ApplyUpdate', 'id': row.id}})
        },
        handleBusinessAuditing(row) {
          this.setQueryStorage()
          this.$router.push({ name: 'deductionApplyDetail', query: {'type': 'BusinessAuditing', 'id': row.id}})
        },
        handleSuccess(row) {
          this.setQueryStorage()
          this.$router.push({ name: 'deductionApplyDetail', query: {'type': 'ApplySuccess', 'id': row.id}})
        },
        handleUpdate(row){
          this.setQueryStorage()
          this.$router.push({ name: 'deductionApplyDetail', query: {'type': 'ShowShipApply', 'id': row.id}})
        },

        handleAppended(fileList) {
          this.$message({type: 'success', message: '文件上传成功!'})
        },
        handleUpload(row) {
          console.log(row)
          this.apply_id = row.id
          this.object_name = row.deduction_ship_name
          this.$refs.upload.handleOpen()
        },
        loadData() {
          this.loading = true
          let p = []
          p.push(fetchFileTypeList({file_type: "bc"}))

          Promise.all(p)
          .then(res => {
            this.file_type_list = res[0]
          })
          .catch(err => {
            this.loading = false
            this.$error_message(err)
          })
        },
        handleSubmit(row) {
            this.$confirm('提交审核后，将不能再修改内容, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
            submitDeductionApply({id: row.id})
              .then(res => {
                this.$message.success(res)
                this.getList()
              })
              .catch(err => {
                this.$error_message(err)
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          },
        handleReject(row) {
          var msg = '是否拒绝该申请？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          }).then(() => {
            rejectShipApply({'id':row.id})
              .then(() => {
                this.$message({
                  type: 'success',
                  message: '拒绝成功!'
                })
                this.getList()
              })
              .catch(error => {
                this.$message.error(error)
              })
          })
        },
        handleSearch() {
          this.getList()
        },
        getList() {

          // 从数据库中加载用户数据
          this.listLoading = true
          getDeductionList(this.query)

            .then(res => {
              this.list = res.results
              this.total = res.count
              this.listLoading = false
              window.localStorage.removeItem('query')
              this.$emit("toIndex", res.count)
            })
            .catch((error) => {
              this.listLoading = false
              this.$error_message(error)
            })
        },
      },
      created() {
        this.query = JSON.parse(window.localStorage.getItem('query')) || {
            search: '',
            offset: 0,
            limit: 20,
            
          }
        this.getList()
        this.loadData()
      }
    }
  </script>
  